import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { BehaviorSubject, Observable, Subject, of } from 'rxjs';
import { timeout, switchMap } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { imageToDataUrl, needsImageProxy } from 'src/app/utils/image-proxy';
import * as QRCode from 'qrcode';
import html2canvas from 'html2canvas';
@Injectable({
  providedIn: 'root'
})
export class SharedService {

  constructor(
    private http: HttpClient,
    private sanitizer: DomSanitizer,
  ) { }

  private executeFilter = new Subject<void>();
  executeFilter$ = this.executeFilter.asObservable();

  executeFilterFunction(): void {
    this.executeFilter.next()
  }

  getWelcomeContent(): Observable<any> {
    return this.http
      .get<any>(environment.apiUrl + `/v2/public/welcome-content`);
  }

  dataURLtoFile(dataurl, filename) {
    if (dataurl) {
      var arr = dataurl.split(','),
        mime = arr[0].match(/:(.*?);/)[1],
        bstr = atob(arr[1]),
        n = bstr.length,
        u8arr = new Uint8Array(n);
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
      }
    }
    return new File([u8arr], filename, { type: mime });
  }

  formatGETId(membershipKey = 0, userId = 0) {

    const padLeft = (numb: number, size: number) => {
      let s = numb + '';
      while (s.length < size) { s = '0' + s; }
      return s;
    }

    const a = padLeft(membershipKey, 4);
    const formatedUserId = padLeft(userId, 8);

    const b = formatedUserId.substring(0, 4);
    const c = formatedUserId.substring(4, 8);

    return a + '-' + b + '-' + c;

  }

  async toBase64(imageUrl: string): Promise<string> {
    return imageToDataUrl(imageUrl);
  }

  getUnreadNotification(): Observable<any> {
    return this.http
      .get<any>(environment.apiUrl + '/v2/account/user-notifications');
  }

  readNotification(item): Observable<any> {
    return this.http
      .post<any>(environment.apiUrl + '/v2/account/read-notification', JSON.stringify(item));
  }

  getEventsList() {
    return this.http
      .post<any>(environment.apiUrl + '/api/rider/appointments', '');
  }

  async spIDTemplateData(details) {
    const main: any = details
    const card: any = details.masterDetails;
    const now = new Date(card?.qrcode?.dateIssued);
    const plusOneYear = new Date(card?.qrcode?.dateIssued);
    plusOneYear.setFullYear(now.getFullYear() + 1);

    const issuedDate = card?.qrcode ? this.formatDateMMDDYYYY(now) : 'N/A';
    const validUntil = this.formatDateMMDDYYYY(plusOneYear);

    const spDemographics = card?.demographic?.filter(
      (demo) => demo.code === 'SP' && demo.status === 'verified'
    ) || [];

    const family_members = card?.family_members?.filter(
      (member) => member.beneficiary === 'yes'
    ) || [];

    // ✅ Join their typeValue (e.g. "a7 / c / a5")
    const joinedTypeValues = spDemographics
      .map(d => d.typeValue)
      .filter(Boolean)
      .join(', ');

    // ✅ Optionally join their type descriptions too if needed
    const joinedTypeDescriptions = spDemographics
      .map(d => d.type)
      .filter(Boolean)
      .join(' / ');

    const middleInitial = card?.lguMiddle
      ? card.lguMiddle.charAt(0).toUpperCase() + '.'
      : '';

    const address = [
      card?.lguStreet,
      card?.lguBarangay,
      card?.lguMunicity,
      card?.lguProvince
    ]
      .map(v => (v || '').trim())
      .filter(v => v)
      .join(', ');

    let card_data: any = {
      template: 'SP',
      // Which artwork this person is issued, held per person on the master.
      design: card?.idDesign === 'commemorative' ? 'commemorative' : 'standard',
      uuid: card?.uuid,
      id: card?.unified_id,
      picture: null,
      signature: null,
      fullName: `${card?.lguLast || ''}${card?.lguExt ? ' ' + card.lguExt : ''}, ${card?.lguFirst || ''} ${middleInitial || ''}`,
      gender: (card?.lguGender === 'M') ? 'MALE' : 'FEMALE',
      dob: card?.lguBDM + '/' + card?.lguBDD + '/' + card?.lguBDY,
      address: address,
      validUntil,
      emergency_contact: this.formatName(card?.lguContact),
      emergency_contact_no: (card?.lguContactNo) ? '(+63) ' + card?.lguContactNo.substring(1) : '',
      emergency_contact_address: '',
      qrcode: card?.qrcode,
      sp_category: joinedTypeValues,
      qualification_code: '',
      dependents: family_members,
      city: card?.lguCity,
      province: card?.lguProvince,
      mayor: main?.scp_org?.lguMayorName,
      cimswdo: main?.createdBy,
      civil: card?.lguCivil,
      issuedDate,
      bloodType: card?.bloodType ? card?.bloodType : 'N/A'
    }

    // demographic benefits
    card_data.qualification_code = card?.demographic_benefits
      ?.filter(b => b?.status === 'active' && b?.benefit?.status === 'active')
      ?.map(b => b?.benefit?.benefitCode)
      ?.join(', ') || 'N/A';

    /** ✅ generate qrcode asynchronously */
    const svg = await QRCode.toString(JSON.stringify(card.qrcode), {
      type: 'svg',
      margin: 0,
      width: 180,
      errorCorrectionLevel: 'H'
    });

    const svgWithLogo = svg.replace(
      '</svg>',
      `<rect x="34" y="36" width="21" height="19" fill="white" />` +
      `<image x="34.5" y="35.5" width="20" height="20"
             xlink:href="/assets/img/admin/id-template/dswd-logo.png" /></svg>`
    );

    card_data.qrcode = this.sanitizer.bypassSecurityTrustHtml(svgWithLogo);
    /** end generate qrcode */

    if (card.documents.length > 0) {
      card.documents.forEach(doc => {
        switch (doc.type.docName) {
          case 'Profile Picture':
            card_data.picture = doc.docUrl;
            break;
          case 'eSignature':
            if (doc.status !== 'active') return;
            card_data.signature = doc.docUrl;
            break;
          default:
          // do nothing
        }
      });
    }

    return card_data;
  }
  async pwdIDTemplateData(details) {
    const main: any = details
    const card: any = details.masterDetails;
    const now = new Date(card?.qrcode?.dateIssued);
    const plusFiveYears = new Date(card?.qrcode?.dateIssued);
    plusFiveYears.setFullYear(now.getFullYear() + 5);

    const dateIssued = card?.qrcode ? this.formatDateMMDDYYYY(now) : 'N/A';
    const validUntil = card?.qrcode ? this.formatDateMMDDYYYY(plusFiveYears) : 'N/A';

    const middleInitial = card?.lguMiddle
      ? card.lguMiddle.charAt(0).toUpperCase() + '.'
      : '';

    const address = [
      card?.lguStreet,
      card?.lguBarangay,
      card?.lguMunicity,
      card?.lguProvince
    ]
      .map(v => (v || '').trim())
      .filter(v => v)
      .join(', ');
    let card_data: any = {
      uuid: card?.uuid,
      template: 'PWD',
      // Which artwork this person is issued, held per person on the master.
      design: card?.idDesign === 'commemorative' ? 'commemorative' : 'standard',
      id: card?.unified_id,
      picture: null,
      signature: null,
      fullname: `${card?.lguLast || ''}${card?.lguExt ? ' ' + card.lguExt : ''}, ${card?.lguFirst || ''} ${middleInitial || ''}`,
      gender: (card?.lguGender === 'M') ? 'MALE' : 'FEMALE',
      dob: card?.lguBDM + '/' + card?.lguBDD + '/' + card?.lguBDY,
      civil_status: card?.lguCivil,
      blood_type: card?.bloodType ? card?.bloodType : 'N/A',
      address: address,
      disabilities: card.demographic.filter(item => item.code !== 'IP' && item.status == 'verified').map(item => item.type).join(', '),
      dateIssued,
      validUntil,
      emergency_contact: this.formatName(card?.lguContact),
      emergency_contact_no: this.formatPhone(card?.lguContactNo),
      qrcode: ''
    }
    /** generate qrcode */
    const svg = await QRCode.toString(JSON.stringify(card.qrcode), {
      type: 'svg', margin: 0, width: 164, errorCorrectionLevel: 'H'
    });
    const svgWithLogo = svg.replace(
      '</svg>',
      `<rect x="34" y="36" width="21" height="19" fill="white" />` +
      `<image x="34.5" y="35.5"
                width="20" height="20"
                xlink:href="/assets/img/admin/id-template/dswd-logo.png" /></svg>`
    );
    card_data.qrcode = this.sanitizer.bypassSecurityTrustHtml(svgWithLogo);
    /** end generate qrcode */

    if (card.documents.length > 0) {
      card.documents.forEach(doc => {
        switch (doc.type.docName) {
          case 'Profile Picture':
            card_data.picture = doc.docUrl;
            break;
          case 'eSignature':
            card_data.signature = doc.docUrl;
            break;
          default:
          // do nothing
        }
      });
    }

    return card_data;
  }

  formatDateMMDDYYYY(date: Date): string {
    const mm = (date.getMonth() + 1).toString().padStart(2, '0');  // months are 0-based
    const dd = date.getDate().toString().padStart(2, '0');
    const yyyy = date.getFullYear();
    return `${mm}/${dd}/${yyyy}`;
  }
  
  middleInitial(name: string | null | undefined): string {
    const trimmed = (name ?? '').trim();

    return trimmed ? trimmed.charAt(0).toUpperCase() + '.' : '';
  }
  formatName(fullName: string): string {
    if (!fullName) return '';

    const trimmed = fullName.trim();
    if (trimmed.includes(',')) return trimmed;

    const parts = trimmed.split(/\s+/);

    if (parts.length === 1) {
      return parts[0];
    }

    const suffixRe = /^(JR|SR|I{1,3}|IV|V|VI{0,3})\.?$/i;
    let suffix = '';
    if (parts.length > 2 && suffixRe.test(parts[parts.length - 1])) {
      suffix = ' ' + parts.pop();
    }

    const middleIdx = parts.findIndex(
      (p, i) => i > 0 && i < parts.length - 1 && /^[A-Za-z]\.?$/.test(p)
    );

    if (middleIdx > 0) {
      const first = parts.slice(0, middleIdx).join(' ');
      const middle = parts[middleIdx].charAt(0).toUpperCase() + '.';
      const last = parts.slice(middleIdx + 1).join(' ');
      return `${last}${suffix}, ${first} ${middle}`;
    }

    const last = parts[parts.length - 1];
    const first = parts.slice(0, -1).join(' ');
    return `${last}${suffix}, ${first}`;
  }

  formatPhone(number: string): string {
    if (!number) return '';

    // remove all non-numeric chars
    let cleaned = number.replace(/\D/g, '');

    // normalize to 9XXXXXXXXX
    if (cleaned.startsWith('63')) {
      cleaned = cleaned.substring(2);
    } else if (cleaned.startsWith('0')) {
      cleaned = cleaned.substring(1);
    }

    // ensure it starts with 9
    if (!cleaned.startsWith('9')) return number; // fallback if invalid

    // limit to 10 digits (9131331234)
    cleaned = cleaned.substring(0, 10);

    const formatted = cleaned.replace(
      /^(\d{3})(\d{3})(\d{4})$/,
      '$1-$2-$3'
    );

    return `+63 ${formatted}`;
  }

  async htmlCanvas(element: HTMLElement): Promise<string> {
    // Inline SVG <image> tags
    await this.inlineSVGImages(element);
   
    await this.inlineCrossOriginImages(element);

    // Wait for all images to load
    await this.waitForImages(element);

    // Has to run after waitForImages — it reads the images' natural size, which
    // is only known once they have decoded. See the method for what it defends
    // against.
    await this.sizeUnsizedSvgImages(element);

    try {
      await document.fonts.ready;
      const canvas: any = await html2canvas(element, {
        scale: 3,
        allowTaint: true,
        backgroundColor: '#ffffff',
        proxy: `${environment.apiUrl}api/v1/public/image-proxy`,
        /*
         * Capture the card at its own size, not at the size the phone happens
         * to show it.
         *
         * The dashboard shrinks the card to fit the viewport —
         * `[style.transform]="'scale(' + idScale + ')'"` on #captureArea, where
         * `idScale = min(1, available / natural)`. html2canvas honours a
         * transform (unlike CSS `zoom`, which it does not implement at all), so
         * it sized the canvas from the SHRUNKEN box: the same card downloaded
         * at a different resolution on every screen width, and always lower on
         * a narrow one. A 360px phone against a 395px card gives ~0.84, so the
         * saved PNG lost about a sixth of its pixels for no reason.
         *
         * Cleared on html2canvas's own copy of the DOM, so nothing flickers on
         * screen while the capture runs, and the card keeps fitting the
         * viewport as before.
         */
        onclone: (_documentClone: Document, clone: HTMLElement) => {
          clone.style.transform = 'none';
        },
      })
      const imgData = canvas.toDataURL('image/png');
      return imgData;

    } catch (e) {
      console.error('Error creating image:', e);
      throw e;
    }
  }
  private waitForImages(element: HTMLElement): Promise<void> {
    const images = Array.from(element.querySelectorAll('img')) as HTMLImageElement[];
    const promises = images.map(img => {
      if (img.complete && img.naturalHeight !== 0) return Promise.resolve();
      return new Promise<void>((resolve, reject) => {
        img.onload = () => resolve();
        img.onerror = () => {
          console.warn('Image failed to load:', img.src);
          resolve(); // resolve anyway to avoid blocking
        };
      });
    });
    return Promise.all(promises).then(() => { });
  }

  // Inline SVG images as Base64
  /**
   * The CSS default object size, 300x150 (CSS Images 3 §5.1). What the browser
   * reports for a replaced element that has no intrinsic size of its own.
   */
  private static readonly DEFAULT_OBJECT_W = 300;
  private static readonly DEFAULT_OBJECT_H = 150;

  /**
   * Rasterises any `<img>` whose SVG source carries no intrinsic size.
   *
   * html2canvas 1.4.1 draws a replaced element with
   *
   *   ctx.drawImage(image, 0, 0, intrinsicWidth, intrinsicHeight, box…)
   *
   * (`CanvasRenderer.renderReplacedElement`) and takes `intrinsicWidth` /
   * `intrinsicHeight` straight from `img.naturalWidth` / `naturalHeight`.
   *
   * An SVG declaring only a `viewBox` has an intrinsic *ratio* but no intrinsic
   * *size*, so the browser reports the default object size fitted to that ratio
   * — 238x150 for the card artwork — while the bitmap it rasterises for
   * `drawImage` is at the destination size, 972x615 at scale 3. html2canvas
   * therefore samples the top-left 238x150 of a 972x615 bitmap and stretches it
   * over the whole card: a ~4.1x zoom into one corner of the artwork, on screen
   * nowhere to be seen. That is the "background image appears zoomed in when
   * downloading the ID" report.
   *
   * Redrawing the file into a canvas gives the `<img>` a real natural size, so
   * the source rectangle html2canvas computes is the whole image.
   *
   * The raster is a fixed RASTER_EDGE px on its long side, not a multiple of the
   * element's measured box. The measured box is the wrong basis: it already
   * includes the CSS `zoom` on the card preview hosts and the `transform` the
   * self-service card uses, so multiplying it by the capture scale — which
   * carries the same zoom again — counts those factors twice. A constant is also
   * bounded, which a multiple of a measured box is not.
   *
   * 3072 is set from the largest capture this app actually takes, measured
   * rather than reasoned: a card inside the 1.6 zoom host produces a 2486px-wide
   * canvas. 2048 would sit under that and soften the guilloche and the
   * "DSWD PWD ID" microtext — see `.v2-art` in the commemorative template for
   * why that detail matters. Rasterising the 2MB card front at this size costs
   * about 600ms, once, and only for artwork that is already broken for export.
   *
   * The artwork in the repo carries `width`/`height` and does not need this;
   * this is here so that a replacement dropped in without them degrades to a
   * correct render instead of a silently wrong one. `card-artwork.spec.ts` is
   * what keeps the assets themselves honest.
   */
  private static readonly RASTER_EDGE = 3072;

  private async sizeUnsizedSvgImages(element: HTMLElement): Promise<void> {
    const images = Array.from(element.querySelectorAll('img')) as HTMLImageElement[];

    for (const img of images) {
      if (!this.hasNoIntrinsicSize(img)) continue;

      // Only for its aspect — see above for why its magnitude is not used.
      const rect = img.getBoundingClientRect();
      if (!rect.width || !rect.height) continue;

      try {
        const edge = SharedService.RASTER_EDGE;
        const landscape = rect.width >= rect.height;

        const canvas = document.createElement('canvas');
        canvas.width = Math.max(1, Math.round(landscape ? edge : edge * (rect.width / rect.height)));
        canvas.height = Math.max(1, Math.round(landscape ? edge * (rect.height / rect.width) : edge));

        const ctx = canvas.getContext('2d');
        if (!ctx) continue;

        // Drawn to fill the canvas, which is the box the layout gave it — the
        // same result the browser paints on screen for `width/height: 100%`.
        ctx.drawImage(img, 0, 0, canvas.width, canvas.height);

        img.src = canvas.toDataURL('image/png');
        await img.decode().catch(() => undefined);
      } catch (e) {
        // A tainted canvas or an undecodable file. The capture is still worth
        // attempting; at worst the artwork comes out as it does today.
        console.warn('Could not size SVG artwork for capture:', img.src, e);
      }
    }
  }

  /**
   * Whether this image reported the browser's default object size rather than a
   * size of its own — the signature of an SVG with no `width`/`height`.
   *
   * The default box is fitted to the file's own ratio, so exactly one of the two
   * dimensions survives it unchanged; which one depends on whether the artwork
   * is wider or taller than 2:1. Testing both is what catches either case.
   *
   * A false positive costs nothing: an SVG that genuinely measures 300 or 150 is
   * redrawn at its own rendered size, which is what it was going to be drawn at.
   */
  private hasNoIntrinsicSize(img: HTMLImageElement): boolean {
    const src = img.currentSrc || img.src || '';
    const isSvg = /\.svg(\?|#|$)/i.test(src) || src.startsWith('data:image/svg+xml');
    if (!isSvg) return false;

    return (
      Math.round(img.naturalWidth) === SharedService.DEFAULT_OBJECT_W ||
      Math.round(img.naturalHeight) === SharedService.DEFAULT_OBJECT_H
    );
  }

  private async inlineCrossOriginImages(element: HTMLElement) {
    const images = Array.from(element.querySelectorAll('img')) as HTMLImageElement[];

    const failures: string[] = [];

    for (const img of images) {
      const src = img.getAttribute('src');
      if (!src || !needsImageProxy(src)) continue;

      try {
        img.setAttribute('src', await imageToDataUrl(src));
      } catch (e: any) {
        console.warn('Could not inline image for capture:', src, e);
        failures.push(e?.message || String(e));
      }
    }

    /*
     * Raised, not warned past.
     *
     * Every cross-origin image on a card is one of the holder's own documents —
     * the photo, the ghost image, a signature; the artwork and the marks are
     * local assets and never reach here. One that cannot be inlined is simply
     * absent from the capture, and the download that used to follow was an ID
     * card with a blank white square where the holder's picture belongs, handed
     * over with no indication anything had gone wrong. A card that fails to
     * download is recoverable; one that prints without a photo is not.
     *
     * This is what a failing image proxy now looks like to the person clicking
     * download — see PublicController::proxy for the limit that makes it fail.
     */
    if (failures.length) {
      throw new Error(
        `${failures.length} image(s) on this card could not be loaded for download: ${failures[0]}`,
      );
    }
  }

  private async inlineSVGImages(element: HTMLElement) {
    const svgImages = element.querySelectorAll('svg image');
    for (const img of Array.from(svgImages)) {
      const hrefAttr = img.getAttribute('href') || img.getAttributeNS('http://www.w3.org/1999/xlink', 'href');
      if (!hrefAttr) continue;

      try {        
        const dataUrl = await imageToDataUrl(hrefAttr);

        img.setAttribute('href', dataUrl);
      } catch (err) {
        console.warn('Failed to inline SVG image:', hrefAttr, err);
      }
    }
  }
}
